import { render } from "./ItemShopSlot.vue?vue&type=template&id=7228787a"
import script from "./ItemShopSlot.vue?vue&type=script&lang=js"
export * from "./ItemShopSlot.vue?vue&type=script&lang=js"

import "./ItemShopSlot.vue?vue&type=style&index=0&id=7228787a&lang=scss"

import exportComponent from "/var/www/html/ran-web/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QEditor from 'quasar/src/components/editor/QEditor.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QTooltip,QBtn,QDialog,QCard,QCardSection,QCardActions,QSelect,QInput,QEditor,QFile,QList,QItem,QItemSection,QRadio,QItemLabel});qInstall(script, 'directives', {Ripple});
